import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/apiClient';

interface DashboardStats {
  totalUsers: number;
  totalUsersChange: number;
  todayNewUsers: number;
  todayNewUsersChange: number;
  revenue: number;
  revenueThisMonth: number;
  revenueChange: number;
  orders: number;
  ordersChange: number;
  recentActivities: Array<{
    type: 'SIGNUP' | 'ORDER';
    title: string;
    description?: string;
    createdAt: string;
    id: number;
    targetId: number | null;
  }>;
}

// API 호출 함수 (별도 파일에서 관리)
const fetchDashboardStats = async (): Promise<DashboardStats> => {
  const response = await apiClient.get<DashboardStats>('/dashboard/stats');
  return response.data;
};

const defaultStats = {
  totalUsers: 1234,
  totalUsersChange: 0,
  todayNewUsers: 456,
  todayNewUsersChange: 0,
  revenue: 12345678,
  revenueThisMonth: 0,
  revenueChange: 0,
  orders: 789,
  ordersChange: 0,
  recentActivities: [],
};

export const useDashboardStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: fetchDashboardStats,
    staleTime: 0, // 항상 최신 데이터 가져오기
    retry: false, // 재시도 안 함
    refetchOnWindowFocus: true, // 윈도우 포커스 시 재요청
    initialData: defaultStats,
  });
};
